import {ListActionButton} from "components/common";
import {ColumnsEdit} from "types/models/column-table-edit";
import React from "react";
import dayjs from "dayjs";
import {ColumnProps} from "../../../../../../../../types/models";

const Columns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    align: "center",
    fixed: "left",
    width: 60,
    isResizable: true,
  },
  {
    title: "Mã nghỉ phép",
    key: "maNghiPhep",
    show: true,
    dataIndex: "maNghiPhep",
    width: 80,
    isResizable: true,
    align: "left",
  },
  {
    title: "Phép tháng",
    key: "phepThang",
    show: true,
    dataIndex: "phepThang",
    width: 100,
    isResizable: true,
    align: "center",
  },
  {
    title: "Phép ốm năm",
    key: "phepNghiOmNam",
    show: true,
    dataIndex: "phepNghiOmNam",
    width: 100,
    isResizable: true,
    align: "center",
  },
  {
    title: "Ngày áp dụng từ ngày",
    key: "ngayApDungTu",
    show: true,
    dataIndex: "ngayApDungTu",
    width: 100,
    align: "center",
    isResizable: true,
    render: (v, r, idx) => v !==null ? dayjs(v).format("DD/MM/YYYY") : null ,
  },
  {
    title: "Ngày áp dụng đến ngày",
    key: "ngayApDungDen",
    show: true,
    dataIndex: "ngayApDungDen",
    width: 100,
    align: "center",
    isResizable: true,
    render: (v, r, idx) => v !==null ? dayjs(v).format("DD/MM/YYYY") : null ,
  },

  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    editable: true,
    width: 140,
    show: true,
    align: "center",
  },
];

export {Columns};
